import { render, staticRenderFns } from "./compareCategory.vue?vue&type=template&id=b54ec6f0&scoped=true"
import script from "./compareCategory.vue?vue&type=script&lang=js"
export * from "./compareCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54ec6f0",
  null
  
)

export default component.exports